import axios from 'axios';
// initial state
// shape: [{ id, quantity }]
const state = () => ({
    list: [],
    take: 25,
    skip: 0,
    columns: [
        {
            table: "search_index_name",
            direction : "ASC",
            direction_pos : 0,
            sortkey : "value",

            key: "name.en",
            label: "name",
            setable: false,
            class: "is-2",
            display: true
        },
        {
            table: "search_index_short_name",
            direction : "ASC",
            direction_pos : 0,
            sortkey : "value",

            key: "short_name.en",
            label: "short_name",
            display: true,
        },
    ],
    loaded: false,
    loadingMore: false,
    loading: false,
    allLoaded: false,
    addNew: false,
    infinity : {
        active : false,
    },
    workingOn: [],
    pagination: {
        currentPage: 1,
        totalPageCount: 0,
        pagesize: 5
    },
    meta : {},
    allUnits: []
})

// getters
const getters = {
    isWorkingOn: (state) => (id) => {
        var index = state.workingOn.findIndex(id);
        if (index >= 0) {
            return true;
        } else {
            return false;
        }
    },
    getUnitById: (state) => (id) => {
        var index = state.allUnits.findIndex(item => item.id == id);
        if(index > -1){
            return state.allUnits[index];
        }
        return {name : ""};
    },
}

// actions
const actions = {
    async load({ commit, state, rootState }, page = 1) {
        commit("skip", (page - 1) * state.take);
        commit("isLoading", true);
            await axios.get(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/units", { params: { take: state.take, skip: state.skip, table_columns: state.columns } }).then((response) => {
                commit("setList", response.data.data);
                commit("pagination", _.get(response, "data.meta.pagination", { total: 0, take: state.take }))
                commit("isLoading", false);
                commit("setAllUnits", response.data.all_units);
            })
        commit("isLoading", false);
    },
    async update({ commit, state, rootState }, data) {
        await axios.post(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/units/" + data.id, data).then(response => {
            commit("update", response.data.data);
        })
    },
    async store({ commit, state, rootState }, data) {
        await axios.put(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/units", data).then(response => {
            commit("unshift", response.data.data);
        })
    },
    async delete({commit, state, rootState}, data){
        await axios.delete(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/units/" + data.id).then(response => {
            commit("removeId", response.data.deleted);
        })
    }
}

// mutations
const mutations = {
    removeId(state, id){
        var index = state.list.findIndex(item => item.id == id);
        if(index >= 0){
            state.list.splice(index, 1);
        }
    },
    pagination(state, object) {
        state.meta = object;
        if (state.skip <= 0) {
            state.pagination.currentPage = 1;
        } else {
            state.pagination.currentPage = (state.skip / state.take) + 1;
        }
        state.pagination.totalPageCount = Math.ceil(state.meta.total / state.take);
        if(state.infinity.active == true && state.meta.total <= state.skip){
            state.allLoaded = true;
        }
    },
    skip(state, skip) {
        state.skip = skip;
    },
    clean(state) {
        state.list = [];
        state.pagination = {
            currentPage: 1,
            totalPageCount: 0,
            pagesize: 5
        };
    },
    subLoading(state, mail) {
        var index = state.workingOn.findIndex(item => item = mail.id);
        if (index >= 0) {
            state.workingOn.splice(index, 1);
        } else {
            state.workingOn.push(mail.id);
        }
    },
    update(state, element) {
        var index = state.list.findIndex(item => item.id == element.id);
        state.list[index] = element;
    },
    unshift(state, element) {
        state.list.unshift(element);
    },
    setList(state, list) {
        if (list == undefined || list.length <= 0) {
            state.allLoaded = true;
        }
        if (state.infinity.active == true) {
            state.list.push(...list);
        } else {
            state.list = list;
        }
    },
    setSteps(state, list) {
        if (list == undefined || list.length <= 0) {
            state.allLoaded = true;
        }
        state.steps.push(...list);
    },
    increasePage(state) {
        state.loadingMore = true;
        state.page++;
    },
    isLoading(state, status) {
        state.loadingMore = status;
        state.loading = status;
    },
    setAllUnits(state, list) {
        state.allUnits = list;
    },
    updateColumn(state, column){
        var index = state.columns.findIndex(item => item.key == column.key)
        for(let i in state.columns){
            state.columns[i].direction_pos += 1;
        }
        if(index > -1){
            column.direction_pos = 0;
            state.columns[index] = column;
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
    }
}
